<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'
import { headerVariants, type TableHeaderVariants } from '.'

type TableHeadProperties = {
  class?: HTMLAttributes['class']
  align?: TableHeaderVariants['align']
  width?: string | undefined
}

const properties = defineProps<TableHeadProperties>()
</script>

<template>
  <th :class="cn('atabix-table-head', headerVariants({ align: properties.align }), properties.class)" :style="{ width }">
    <slot />
  </th>
</template>

<style lang="scss">
.atabix-table-head {
  display: initial flex;
  @apply flex-col gap-2;
  @apply p-4;
  @apply align-middle;
  @apply text-base;
  @apply font-semibold;
  @apply select-none;
  @apply text-table-foreground-header;

  &:has([role='checkbox']) {
    @apply pr-0;
  }
}
</style>
